export default __webpack_public_path__ + "static/media/waitNextRound.6366900d.mp3";